export default __webpack_public_path__ + "static/hohmann-transfer-neat-24482f986dae58d7b6f31a93a1b61cb3.gif";